"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.describeAccountEvent = describeAccountEvent;
exports.AccountEventsList = AccountEventsList;
const react_1 = __importStar(require("react"));
const personsV2Helpers_1 = require("../../Persons/personsV2Helpers");
const MainSetupReact_1 = __importDefault(require("../../React/MainSetupReact"));
/**
 * ROD-3: sekcja „Ostatnie zmiany konta" w modalu uprawnień - kto, kiedy i co zmienił
 * w koncie osoby. Sam odczyt; zdarzenia pisze backend w transakcji zmiany.
 *
 * Etykiety zależą od PARY (rodzaj zdarzenia, pole), bo `isActive` znaczy co innego w koncie
 * (logowanie) i w panelu (widoczność w scrumie - decyzja ownera D-ROD-3).
 */
const FIELD_LABELS = {
    "ACCOUNT.systemRoleId": "Rola",
    "ACCOUNT.systemEmail": "E-mail logowania",
    "ACCOUNT.isActive": "Konto aktywne",
    "ACCOUNT.fidmanEnabled": "Użytkownik FIDmana",
    "PROJECT_ASSIGNMENTS.projectOurIds": "Zakres projektów",
    "STAFF_FLAGS.isDriver": "Kierowca",
    "STAFF_FLAGS.isInScrum": "W scrumie",
    "STAFF_FLAGS.hasCostInvoiceAccess": "Faktury kosztowe",
    "STAFF_FLAGS.hasBankAccess": "Wyciągi bankowe",
    "STAFF_FLAGS.canLogSiteVisits": "Wizyty na budowie",
    "STAFF_FLAGS.canManageSbAccess": "Zarządza dostępem do SB",
    "STAFF_FLAGS.isActive": "Aktywny (panel)",
};
/** Numer roli -> nazwa roli ze słownika MainSetup; gdy słownika brak, zostaje numer. */
function roleName(id) {
    try {
        const roles = MainSetupReact_1.default?.SystemRoles ?? {};
        const hit = Object.entries(roles).find(([, role]) => Number(role?.id) === Number(id));
        return hit ? hit[0] : String(id);
    }
    catch {
        return String(id);
    }
}
function formatValue(raw, field) {
    if (raw === null || raw === undefined)
        return "—";
    let value;
    try {
        value = JSON.parse(raw);
    }
    catch {
        return raw;
    }
    if (value === null)
        return "—";
    if (typeof value === "boolean")
        return value ? "tak" : "nie";
    if (Array.isArray(value))
        return value.length ? value.join(", ") : "brak";
    if (field === "systemRoleId")
        return roleName(value);
    return String(value);
}
/** Reguła „co pokazać" - osobno, żeby dało się ją testować bez renderowania. */
function describeAccountEvent(event) {
    const key = `${event.eventType}.${event.field}`;
    const who = [event._editorName, event._editorSurname].filter(Boolean).join(" ") || "—";
    const when = event._createdAt ? new Date(event._createdAt).toLocaleString("pl-PL") : "—";
    return {
        when,
        who,
        what: FIELD_LABELS[key] ?? event.field,
        before: formatValue(event.valueBefore, event.field),
        after: formatValue(event.valueAfter, event.field),
    };
}
function AccountEventsList({ personId }) {
    const [events, setEvents] = (0, react_1.useState)(null);
    const [failed, setFailed] = (0, react_1.useState)(false);
    (0, react_1.useEffect)(() => {
        if (!personId) {
            setEvents([]);
            return;
        }
        let cancelled = false;
        setEvents(null);
        setFailed(false);
        (0, personsV2Helpers_1.fetchPersonAccountEvents)(personId)
            .then((list) => {
            if (!cancelled)
                setEvents(list);
        })
            .catch(() => {
            if (cancelled)
                return;
            setFailed(true);
            setEvents([]);
        });
        return () => {
            cancelled = true;
        };
    }, [personId]);
    return (react_1.default.createElement("div", { className: "mt-3", "data-testid": "account-events" },
        react_1.default.createElement("hr", null),
        react_1.default.createElement("h6", null, "Ostatnie zmiany konta"),
        failed && react_1.default.createElement("div", { className: "text-danger small" }, "Nie uda\u0142o si\u0119 pobra\u0107 historii zmian."),
        events === null && !failed && react_1.default.createElement("div", { className: "text-muted small" }, "Wczytywanie\u2026"),
        events !== null && events.length === 0 && !failed && (react_1.default.createElement("div", { className: "text-muted small" }, "Brak zapisanych zmian.")),
        events !== null && events.length > 0 && (react_1.default.createElement("ul", { className: "list-unstyled small mb-0", style: { maxHeight: 220, overflowY: "auto" } }, events.map((event) => {
            const view = describeAccountEvent(event);
            return (react_1.default.createElement("li", { key: event.id ?? `${event._createdAt}-${event.field}`, className: "mb-1" },
                react_1.default.createElement("span", { className: "text-muted" }, view.when),
                " \u00B7 ",
                react_1.default.createElement("strong", null, view.who),
                " \u00B7 ",
                view.what,
                ":",
                " ",
                react_1.default.createElement("span", { className: "text-muted" }, view.before),
                " \u2192 ",
                react_1.default.createElement("span", null, view.after)));
        })))));
}
